import {post} from "@/plugins/axios";
/*
 * 协调中心机构添加/修改
 * @constructor jack
 * */
export const xtOrgAdd = (
  org_name,
  org_code,
  username,
  phone,
  code,
  email,
  region_text,
  address,
  xietiao,
  level_id,
  remark,
  desc_past,
  desc_plan,
  longitude,
  latitude,
  item_id
) => post("/Index/index/add_xie", {
  org_name,
  org_code,
  username,
  phone,
  code,
  email,
  region_text,
  address,
  xietiao,
  level_id,
  remark,
  desc_past,
  desc_plan,
  longitude,
  latitude,
  item_id
});


/*
 * 认证培训机构信息添加/修改
 * @constructor jack
 * */
export const orgAddCr2 = (
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  code,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  shengyuan,
  shizi,
  kecheng,
  kecheng_file,
  zhaosheng,
  renshu,
  zhaosheng_file,
  remark,
  item_id,
  february_num,
  june_num,
  september_num,
  four_num,
  sum,
) => post("/Index/index/add_cr2", {
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  code,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  shengyuan,
  shizi,
  kecheng,
  kecheng_file,
  zhaosheng,
  renshu,
  zhaosheng_file,
  remark,
  item_id,
  february_num,
  june_num,
  september_num,
  four_num,
  sum,
});

/*
 * 实习基地信息添加/修改
 * @constructor jack
 * */
export const orgAddS = (
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  code,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  huanjing,
  huanjing_file,
  shixi_desc,
  jihua_num,
  month,
  shizi,
  gangwei,
  remark,
  item_id
) => post("/Index/index/add_s", {
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  code,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  huanjing,
  huanjing_file,
  shixi_desc,
  jihua_num,
  month,
  shizi,
  gangwei,
  remark,
  item_id
});

/*
 * 考场信息添加/修改
 * @constructor jack
 * */
export const orgAddE = (
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  code,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  huanjing_file,
  wifi_env,
  wifi_sulv,
  wifi_max,
  env_image,
  shebei,
  other_shebei,
  teacher,
  pro,
  zhi,
  bear_num,
  remark,
  item_id
) => post("/Index/index/add_e", {
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  code,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  huanjing_file,
  wifi_env,
  wifi_sulv,
  wifi_max,
  env_image,
  shebei,
  other_shebei,
  teacher,
  pro,
  zhi,
  bear_num,
  remark,
  item_id
});


/*
 * 产教融合基地信息添加/修改
 * @constructor jack
 * */
export const orgAddCr = (
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  code,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  course,
  project_teachers,
  project_students,
  other,
  enrollment_plan,
  syllabus,
  teachers,
  funds,
  other_plan,
  project_leader,
  project_team,
  shenpi,
  remark,
  item_id
) => post("/Index/index/add_cr", {
  org_name,
  org_code,
  org_license,
  username,
  zhiwu,
  phone,
  code,
  email,
  region_text,
  address,
  longitude,
  latitude,
  way,
  course,
  project_teachers,
  project_students,
  other,
  enrollment_plan,
  syllabus,
  teachers,
  funds,
  other_plan,
  project_leader,
  project_team,
  shenpi,
  remark,
  item_id
});

/*
 * 产教融合基地信息添加/修改
 * @constructor jack
 * */
export const sendSms = (
  tel
) => post("/index/sendSms", {
 tel
});
